<template>
<nav class="pcoded-navbar">
    <div v-if="checkScope.split(' ').indexOf('translate') > -1" class="pcoded-inner-navbar main-menu">
        <div class="pcoded-navigatio-lavel">Navigation</div>
        <ul class="pcoded-item pcoded-left-item">
            <router-link tag="li" :to="{ name: 'translate.dashboard' }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-home"></i></span>
                    <span class="pcoded-mtext">Dashboard</span>
                </a>
            </router-link>
        </ul>

        <div v-show="user != null" class="pcoded-navigatio-lavel">Translation Jobs</div>
        <ul class="pcoded-item pcoded-left-item">
            <router-link  v-if="user ? user.permission_projects.split(' ').indexOf('1') > -1 : false" tag="li" :to="{ name: 'translate.jobs', params: { project_list_id: '1' } }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-monitor"></i></span>
                    <span class="pcoded-mtext">Cesstant Cloud</span>
                </a>
            </router-link>
            <router-link  v-if="user ? user.permission_projects.split(' ').indexOf('2') > -1 : false" tag="li" :to="{ name: 'translate.jobs', params: { project_list_id: '2' } }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-monitor"></i></span>
                    <span class="pcoded-mtext">Multi Store</span>
                </a>
            </router-link>
        </ul>
    </div>

    <div v-else class="pcoded-inner-navbar main-menu">
        <div class="pcoded-navigatio-lavel">Navigation</div>
        <ul class="pcoded-item pcoded-left-item">
            <router-link tag="li" :to="{ name: 'dashboard' }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-home"></i></span>
                    <span class="pcoded-mtext">Dashboard</span>
                </a>
            </router-link>
            <router-link tag="li" v-if="checkScope === 'everything' || checkScope.split(' ').indexOf('system_list') > -1" :to="{ name: 'index' }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-listine-dots"></i></span>
                    <span class="pcoded-mtext">System List</span>
                </a>
            </router-link>
            <li :class="['pcoded-hasmenu', levelPath[0] === 'license-control' ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="feather icon-server"></i></span>
                    <span class="pcoded-mtext">License Control</span>
                </a>
                <ul class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'license-control.customer-list', params: { search: 'null', filter_exp: 'null', filter_exp_select: 'null', filter_exp_option: 'null', filter_exp_specify_input: 'null', customer: 'null' }}" exact>
                        <a>
                            <span class="pcoded-mtext">Customer List</span>
                        </a>
                    </router-link>
                    <router-link tag="li" v-if="checkScope === 'everything'" :to="{ name: 'license-control.domain-type' }" exact>
                        <a>
                            <span class="pcoded-mtext">Domain Type</span>
                        </a>
                    </router-link>
                    <router-link tag="li" v-if="checkScope === 'everything'" :to="{ name: 'license-control.product-list' }" exact>
                        <a>
                            <span class="pcoded-mtext">Product List</span>
                        </a>
                    </router-link>
                    <router-link tag="li" v-if="checkScope === 'everything'" :to="{ name: 'license-control.server-list' }" exact>
                        <a>
                            <span class="pcoded-mtext">Server List</span>
                        </a>
                    </router-link>
                </ul>
            </li>
            <li v-if="checkScope === 'everything' || checkScope.split(' ').indexOf('sms_gateway') > -1" :class="['pcoded-hasmenu', levelPath[0] === 'sms-gateway' ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="icofont icofont-ui-messaging"></i></span>
                    <span class="pcoded-mtext">SMS Gateway</span>
                </a>
                <ul class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'sms-gateway.sms' }" exact>
                        <a>
                            <span class="pcoded-mtext">Sent SMS</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'sms-gateway.sms-log' }" exact>
                        <a>
                            <span class="pcoded-mtext">SMS Log</span>
                        </a>
                    </router-link>
                </ul>
            </li>
            <li v-if="checkScope === 'everything' || checkScope.split(' ').indexOf('slip_ok') > -1" :class="['pcoded-hasmenu', levelPath[0] === 'slip-ok' ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="icofont icofont-notepad"></i></span>
                    <span class="pcoded-mtext">SLIP Ok</span>
                </a>
                <ul class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'slip-ok.slip' }" exact>
                        <a>
                            <span class="pcoded-mtext">Check Slip</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'slip-ok.slip-log' }" exact>
                        <a>
                            <span class="pcoded-mtext">Slip Log</span>
                        </a>
                    </router-link>
                </ul>
            </li>
            <li v-if="checkScope === 'everything' || checkScope.split(' ').indexOf('flash_order') > -1" :class="['pcoded-hasmenu', levelPath[0] === 'flash-express' ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="icofont icofont-flash"></i></span>
                    <span class="pcoded-mtext">Flash Express</span>
                </a>
                <ul v-if="checkScope === 'everything' || checkScope.split(' ').indexOf('flash_order')" class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'flash-express.order' }" exact>
                        <a>
                            <span class="pcoded-mtext">Flash Order</span>
                        </a>
                    </router-link>
                </ul>
                <!-- <ul v-if="checkScope === 'everything'" class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'flash-express.profile' }" exact>
                        <a>
                            <span class="pcoded-mtext">Flash Profile</span>
                        </a>
                    </router-link>
                </ul> -->
            </li>
            <!-- <li :class="['pcoded-hasmenu', levelPath[0] === 'redirect' ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="icofont icofont-link"></i></span>
                    <span class="pcoded-mtext">Redirect</span>
                </a>
                <ul class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'redirect.other' }" exact>
                        <a>
                            <span class="pcoded-mtext">Other</span>
                        </a>
                    </router-link>
                </ul>
            </li> -->
            <router-link tag="li" v-if="checkScope === 'everything' || checkScope.split(' ').indexOf('sync_upload') > -1" :to="{ name: 'sync-upload' }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-upload"></i></span>
                    <span class="pcoded-mtext">Sync Upload</span>
                </a>
            </router-link>
            <router-link tag="li" :to="{ name: 'ticket', params: { ticket: 'null' } }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-ticket"></i></span>
                    <span class="pcoded-mtext">Ticket</span>
                </a>
            </router-link>
            <router-link tag="li" :to="{ name: 'date_calculator' }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-ui-calendar"></i></span>
                    <span class="pcoded-mtext">Date Calculator</span>
                </a>
            </router-link>
            <router-link tag="li" :to="{ name: 'note' }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-notebook"></i></span>
                    <span class="pcoded-mtext">Note</span>
                </a>
            </router-link>
            <router-link tag="li" v-if="checkScope === 'everything' || checkScope.split(' ').indexOf('download') > -1" :to="{ name: 'download' }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-download"></i></span>
                    <span class="pcoded-mtext">Download</span>
                </a>
            </router-link>
            <router-link tag="li" v-if="checkScope === 'everything'" :to="{ name: 'permission' }" exact>
                <a>
                    <span class="pcoded-micon"><i class="icofont icofont-user"></i></span>
                    <span class="pcoded-mtext">Permission</span>
                </a>
            </router-link>
            <li :class="['pcoded-hasmenu', levelPath[0] === 'settings' ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="icofont icofont-settings"></i></span>
                    <span class="pcoded-mtext">Settings</span>
                </a>
                <ul class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'settings.system-list' }" exact>
                        <a>
                            <span class="pcoded-mtext">System List</span>
                        </a>
                    </router-link>
                </ul>
            </li>
        </ul>

        <div class="pcoded-navigatio-lavel">Project</div>
        <ul class="pcoded-item pcoded-left-item">
            <li :class="['pcoded-hasmenu', (levelPath[0] === 'project' && levelPath[1] === 'cesstant-cloud') ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="icofont icofont-monitor"></i></span>
                    <span class="pcoded-mtext">Cesstant Cloud</span>
                </a>
                <ul class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'document.cesstant-cloud' }" exact>
                        <a>
                            <span class="pcoded-mtext">Documents</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'redirect.cesstant-cloud' }" exact>
                        <a>
                            <span class="pcoded-mtext">Redirect</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'translate.cesstant-cloud' }" exact>
                        <a>
                            <span class="pcoded-mtext">Translate</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'notify.cesstant-cloud' }" exact>
                        <a>
                            <span class="pcoded-mtext">Notify</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'policy.cesstant-cloud' }" exact>
                        <a>
                            <span class="pcoded-mtext">Policy</span>
                        </a>
                    </router-link>
                </ul>
            </li>
            <li :class="['pcoded-hasmenu', (levelPath[0] === 'project' && levelPath[1] === 'multibrand') ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="icofont icofont-monitor"></i></span>
                    <span class="pcoded-mtext">Multi Store</span>
                </a>
                <ul class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'document.multibrand' }" exact>
                        <a>
                            <span class="pcoded-mtext">Documents</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'redirect.multibrand' }" exact>
                        <a>
                            <span class="pcoded-mtext">Redirect</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'translate.multibrand' }" exact>
                        <a>
                            <span class="pcoded-mtext">Translate</span>
                        </a>
                    </router-link>
                </ul>
            </li>
            <li :class="['pcoded-hasmenu', (levelPath[0] === 'project' && levelPath[1] === 'web-management') ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="icofont icofont-monitor"></i></span>
                    <span class="pcoded-mtext">Web Management</span>
                </a>
                <ul class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'document.web-management' }" exact>
                        <a>
                            <span class="pcoded-mtext">Documents</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'redirect.web-management' }" exact>
                        <a>
                            <span class="pcoded-mtext">Redirect</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'notify.web-management' }" exact>
                        <a>
                            <span class="pcoded-mtext">Notify</span>
                        </a>
                    </router-link>

                    <router-link tag="li" :to="{ name: 'policy.web-management' }" exact>
                        <a>
                            <span class="pcoded-mtext">Policy</span>
                        </a>
                    </router-link>
                </ul>
            </li>
            <li :class="['pcoded-hasmenu', (levelPath[0] === 'project' && levelPath[1] === 'other') ? 'active pcoded-trigger' : '']">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="icofont icofont-monitor"></i></span>
                    <span class="pcoded-mtext">Other</span>
                </a>
                <ul class="pcoded-submenu">
                    <router-link tag="li" :to="{ name: 'document.other' }" exact>
                        <a>
                            <span class="pcoded-mtext">Documents</span>
                        </a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'redirect.other' }" exact>
                        <a>
                            <span class="pcoded-mtext">Redirect</span>
                        </a>
                    </router-link>
                </ul>
            </li>
        </ul>

        <!-- <div class="pcoded-navigatio-lavel">Support</div>
        <ul class="pcoded-item pcoded-left-item">
            <li class="">
                <a href="#" target="_blank">
                    <span class="pcoded-micon"><i class="feather icon-help-circle"></i></span>
                    <span class="pcoded-mtext">Submit Issue</span>
                </a>
            </li>
        </ul> -->
    </div>
</nav>
</template>

<script>

import {isLoggedIn, getUser} from '@/services/auth-service';

export default {
    props: {
        levelPath: {
            type: Array,
            default: [],
        },
        scope: null
    },
    data() {
        return {
            user: null
        };
    },
    computed: {
        checkScope() {
            return this.scope;
        }
    },
    created() {
        // console.log(this.scope);
        this.loggedIn = isLoggedIn();
        if(this.loggedIn) {
            getUser().then(res => {
                this.user = res.data;
            });
        }
    },
    methods: {}
};
</script>
